import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateSendMessage = {
  sendMessage: { data: null, loading: false, error: null },
};

export const sendMessage = createAsyncThunk('user/sendMessage', async (data = {}, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .post(`${process.env.REACT_APP_SERVER_API}/chat/chats/${data.chat_id}/messages`, data, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerSendMessage = {
  [sendMessage.pending]: (state) => {
    // state.sendMessage.data = null;
    state.sendMessage.loading = true;
    state.sendMessage.error = null;
  },
  [sendMessage.fulfilled]: (state, action) => {
    state.sendMessage.loading = false;
    state.sendMessage.data = action.payload;
    state.sendMessage.error = null;
  },
  [sendMessage.rejected]: (state, action) => {
    state.sendMessage.loading = false;
    state.sendMessage.error = action.payload;
  },
};
